import {
    Box,
    Button,
    Card,
    Container,
    Flex,
    Grid,
    MultiSelect,
    Portal,
    Select,
    Stack,
    Text,
    Title,
} from '@mantine/core';
import {
    useDebouncedCallback,
    useDisclosure,
    useLocalStorage,
} from '@mantine/hooks';
import { useMemo, useState } from 'react';

import JsonOptionsModal from '../../../../modals/options/JsonOptionsModal';
import { WidgetSection } from '.';
import { pascalToFriendly } from '../../../../../utils/text';

const NetworkInfo = ({ agent, networkState }) => {
    const [jsonModalProps, setJsonModalProps] = useState({});
    const [
        optionsModalOpen,
        { open: openOptionsModal, close: closeOptionsModal },
    ] = useDisclosure();

    const handleShowInterface = (jsonObj) => {
        setJsonModalProps({
            header: 'Interface Info',
            jsonObj: jsonObj,
        });
        openOptionsModal();
    };
    return (
        <>
            <Card
                withBorder
                radius='md'
                px='md'
                className={null}>
                <Title
                    order={5}
                    c={'dimmed'}>
                    Network
                </Title>
                <Card.Section
                    className={null}
                    px={'md'}
                    py='xs'>
                    <Stack gap={5}>
                        <WidgetSection
                            title={'Hostname'}
                            value={agent.containerState?.hostname}
                            badgeValue={agent.containerState?.status}
                        />

                        {networkState.interfaces
                            .filter(
                                (x) =>
                                    x.type != 'Internet' ||
                                    x.ipAddresses.length > 0
                            )
                            .map((x) => (
                                <Box key={x.linkName}>
                                    <WidgetSection
                                        title={'Interface'}
                                        value={x.linkName}
                                        badgeValue={x.type}
                                        withDivider={false}
                                    />
                                    <WidgetSection
                                        title={'IP Address'}
                                        value={x.ipAddresses[0]}
                                        rightSection={
                                            <Button
                                                variant='light'
                                                size={'compact-xs'}
                                                onClick={() =>
                                                    handleShowInterface(x)
                                                }>
                                                Show Details
                                            </Button>
                                        }
                                        mb={'4'}
                                    />
                                </Box>
                            ))}
                    </Stack>
                </Card.Section>
            </Card>
            <JsonOptionsModal
                {...jsonModalProps}
                opened={optionsModalOpen}
                close={closeOptionsModal}
            />
        </>
    );
};
export default NetworkInfo;
